/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Youtube_Export_Privacy_UnlistedInputs */

const cs_youtube_export_privacy_unlisted = /** @type {(inputs: Youtube_Export_Privacy_UnlistedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neveřejné`)
};

const en_youtube_export_privacy_unlisted = /** @type {(inputs: Youtube_Export_Privacy_UnlistedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlisted`)
};

/**
* | output |
* | --- |
* | "Unlisted" |
*
* @param {Youtube_Export_Privacy_UnlistedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const youtube_export_privacy_unlisted = /** @type {((inputs?: Youtube_Export_Privacy_UnlistedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Youtube_Export_Privacy_UnlistedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_youtube_export_privacy_unlisted(inputs)
	return cs_youtube_export_privacy_unlisted(inputs)
});